import Joi from '@hapi/joi'

export const paymentRatesSchema = {
    groupID: Joi.number().invalid(0).required().label("GroupID").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("EstateID").messages({
        "any.invalid": `Please select valid Estate`,
        "any.required": `Estate required`
    }),
    collectionCategoryID: Joi.number().invalid(0).required().label("collectionCategoryID").messages({
        "any.invalid": `Please select valid CollectionCategory`,
        "any.required": `Collection Category required`
    }),

}